"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimatedFab = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var styles_1 = __importDefault(require("./styles"));
var AnimatedFab = function (_a) {
    var children = _a.children, label = _a.label, color = _a.color, props = __rest(_a, ["children", "label", "color"]);
    var _b = (0, react_1.useState)({ color: color }), styleProps = _b[0], setStyleProps = _b[1];
    var styles = (0, styles_1.default)(styleProps);
    (0, react_1.useEffect)(function () {
        setStyleProps({ color: color });
    }, [color]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
        } }, { children: (0, jsx_runtime_1.jsxs)(core_1.Button, __assign({}, props, { variant: "contained", className: styles.button, "aria-label": label }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: styles.label }, { children: label })), (0, jsx_runtime_1.jsx)("div", __assign({ className: styles.icon, role: "button" }, { children: children }))] })) })));
};
exports.AnimatedFab = AnimatedFab;
